/**
 * Barra de ações do editor (PR4 · gate `playbook-author`). Aparece quando há
 * alterações não salvas; oferece Descartar e Salvar. Reflete o estado salvando e
 * uma mensagem de erro genérica (o conflito 409 tem banner próprio na view).
 */

import { Save, Undo2 } from 'lucide-react';

export function PlaybookActionBar({
  isDirty,
  isSaving,
  errorMessage,
  onSave,
  onDiscard,
}: {
  isDirty: boolean;
  isSaving: boolean;
  errorMessage: string | null;
  onSave: () => void;
  onDiscard: () => void;
}): JSX.Element | null {
  if (!isDirty && !isSaving) return null;

  return (
    <div className="pb-actionbar" role="region" aria-label="Ações de edição">
      <span className="pb-actionbar__status">
        {isSaving ? 'Salvando…' : 'Alterações não salvas'}
      </span>
      {errorMessage !== null && <span className="pb-actionbar__error">{errorMessage}</span>}
      <div className="pb-actionbar__buttons">
        <button type="button" className="pb-btn" disabled={isSaving} onClick={onDiscard}>
          <Undo2 size={14} /> Descartar
        </button>
        <button
          type="button"
          className="pb-btn pb-btn--primary"
          disabled={isSaving}
          onClick={onSave}
        >
          <Save size={14} /> Salvar
        </button>
      </div>
    </div>
  );
}
